<template>
  <div v-if="contents.length > 0">
    <h-subheader
      v-if="subheader"
      :disabled="disabled"
      v-text="subheader"
    />
    <template v-for="(content, i) in contents">
      <v-divider
        v-if="i > 0"
        :key="`d${i}`"
        class="mx-3"
      />
      <h-item
        v-if="disabled"
        :key="`i${i}`"
        :content="content"
        :disabled="disabled"
        :closed="closed"
      />
      <h-item
        v-else
        v-ripple
        :key="`ii${i}`"
        :content="content"
        :disabled="disabled"
        :closed="closed"
        @open="$emit('open', $event)"
      />
    </template>
  </div>
</template>

<script>
  import HSubheader from './Subheader'
  import HItem from './Item'

  export default {
    components: {
      HSubheader,
      HItem,
    },

    props: {
      contents: {
        required: true,
        type: Array,
      },
      subheader: {
        required: false,
        type: String,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
      closed: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
  }
</script>
